module.exports = __webpack_public_path__ + "static/josh.40d767d9.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/josh.jpeg
// module id = 169
// module chunks = 0